import PropTypes from 'prop-types';
import { BsCheckCircleFill, BsXLg } from 'react-icons/bs';

import IconButton from '#globalComponents/IconButton/IconButton';

const CallReachedConfirm = ({ onSelect, onCancel }) => (
	<div className="flex items-center gap-1.5 animate-in fade-in">
		<button
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				onSelect(true);
			}}
			className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-control border border-success-500/40 bg-success-200 text-success-700 hover:brightness-95 transition-colors"
		>
			<BsCheckCircleFill className="w-3 h-3" /> Erreicht
		</button>
		<button
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				onSelect(false);
			}}
			className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-control border border-caution-500/40 bg-caution-200 text-caution-700 hover:brightness-95 transition-colors"
		>
			<BsXLg className="w-2.5 h-2.5" /> Nicht erreicht
		</button>
		<IconButton
			icon={BsXLg}
			label="Abbrechen"
			onClick={(e) => {
				e.stopPropagation();
				onCancel();
			}}
			className="h-6 w-6"
		/>
	</div>
);

CallReachedConfirm.propTypes = {
	onSelect: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default CallReachedConfirm;
